import { EpimsBaseEntityDto } from './epim-base.dto';

export class LorpDto extends EpimsBaseEntityDto{
  LorpName: string;
  SubscriptionUserId: string;
  }
